import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useColorScheme, ColorSchemeContext } from "./contexts.js";
const ColorSchemeProvider = memo(
  ({ children, scheme }) => {
    const inheritedColorScheme = useColorScheme();
    return /* @__PURE__ */ jsx(ColorSchemeContext.Provider, { value: scheme ?? inheritedColorScheme, children });
  }
);
ColorSchemeProvider.displayName = "Interface.ColorSchemeProvider";
export {
  ColorSchemeProvider
};
//# sourceMappingURL=ColorSchemeProvider.js.map
